import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import AnswerFeedback from './index';

const AnswerFeedbackRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/answers/:id" component={AnswerFeedback} />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <AnswerFeedbackRoot {...props} />;
